import { MorphListScreen } from '../features/morphs/screens/MorphListScreen';

export const MorphListPage = () => <MorphListScreen />;
